import script from "./CardNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./CardNumber.vue?vue&type=script&setup=true&lang=js"

import "./CardNumber.vue?vue&type=style&index=0&id=4b560336&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b560336"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QLinearProgress});
